import React from 'react';

import {Modal, message} from 'antd';

import moment from 'moment';

import fetch from './fetch';
import utils from './../utils';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},

    {key:'name', label: '文件名称'},
    {key:'logicPath', label: '文件路径'},
    {key:'fileNumber', label: '文件字号'},
    {key:'publishOrgName', label: '发文部门'},
    {key:'publishDate', label: '发布日期', render: (value)=> moment(new Date(value)).format('YYYY/MM/DD')},
    {key:'realName', label: '上传人'},
    {key:'fileDesc', label: '关键字'},
    {key:'termName', label: '所属学期/学年'},
    {type:'action', label: '操作', values: ['read', 'down', 'file']},
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100, }) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}');
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('analysis/targetAnalysisByTarget', Object.assign(defaultsParams, keywords))
    .then(response => {
        return {
            code: response.code,
            data: response.payload.data,
            meta: response.payload.meta.extParams
        };
    });
}


/**
 * @method upload
 * @param {object} [keywords]
 * @return {promise}
 */
const upload = (keywords = {}) => {
    return fetch.post('file/manage/upload', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('file/manage/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const exist = (id) => {
    return fetch.post('file/manage/exist/'+ id)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
            okText:"确认",
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.refresh();
                        DataGrid.selections = [];
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'file'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

export default {
    querySearch,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    remove,
    upload,
    exist
}